/**
 * ProviderJobPage — Uses the same DoorDash-style JobDetails view
 * Handles /provider/job/:requestId route
 */
import JobDetails from '../mechanic/JobDetails';
export default JobDetails;
